var _ellipse, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.93534,
    cy: 19.8949,
    rx: 5.39531,
    ry: 0.962787,
    fill: "#DAFFF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7991 6.62411C11.7991 9.86262 11.7411 10.8263 5.73666 19.9225C0.00885698 10.8677 0.0714398 9.86262 0.0714398 6.62411C0.0714398 3.38559 2.6969 0.760254 5.93529 0.760254C9.17368 0.760254 11.7991 3.38559 11.7991 6.62411Z",
    fill: "#78C2A5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.93525,
    cy: 6.70319,
    r: 2.98102,
    fill: "#DAFFF0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/Location-icon.36106d92f1d426af12123a2ca474a282.svg";
export { ForwardRef as ReactComponent };